<script>
import Layout from '@layouts/main.vue'
import CandidateList from '@/components/candidate/candidate-list.vue'
import CandidateZoom from '@components/candidate/candidate-zoom.vue'
import { mapGetters, mapActions } from 'vuex'
import CandidateListSkeleton from '@/components/skeleton/candidate-list-skeleton.vue'

/**
 * TODO: Need to rework this view and break it up by client.
 */
export default {
  name: 'CandidatesView',
  metaInfo() {
    return {
      title: this.$route?.meta?.title,
      meta: [{ name: 'description', content: 'The Candidates page.' }],
    }
  },
  components: { Layout, CandidateList, CandidateZoom, CandidateListSkeleton },
  data: function() {
    return {
      candidateList: [],
      showCandidateModal: false,
    }
  },
  computed: {
    ...mapGetters({
      getSelectedClients: 'client/getSelectedClients',
      isCanListLoading: 'candidate/isCanListLoading',
    }),
  },
  async mounted() {
    var result = await this.getCandidateList(this.getSelectedClients[0]) // TODO: Rework to handle multiple clients

    if (!result.isSuccess && result.statusCode === 403) {
      alert(this.$t('candidateList.candidateListUnauthorisedError'))
      this.$router.push('/')
    }

    if (result.isSuccess) {
      var list = []
      for (var data of result.data) {
        list.push({
          ...data,
          profileImgSrc: null,
        })
      }
      this.candidateList = list
    }
  },
  methods: {
    ...mapActions({
      getCandidateList: `candidate/getCandidateList`,
    }),
    showCandidateDialog(candidateId) {
      this.selectedCandidate = candidateId
      this.showCandidateModal = true
    },
    closeCandidateDialog() {
      this.selectedCandidate = null
      this.showCandidateModal = false
    },
  },
}
</script>

<template>
  <Layout>
    <BasePageTitle :title="$t('candidates.pageTitle')" />

    <section>
      <CandidateListSkeleton v-if="isCanListLoading" />
      <CandidateList
        v-else-if="candidateList.length > 0"
        :candidate-data="candidateList"
        @viewCandidate="showCandidateDialog"
      ></CandidateList>
    </section>

    <v-dialog
      v-if="showCandidateModal"
      v-model="showCandidateModal"
      width="720px"
      content-class="rounded-xl"
    >
      <CandidateZoom
        :id="selectedCandidate"
        @closeModal="closeCandidateDialog"
      />
    </v-dialog>
  </Layout>
</template>
